import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import LastSalePriceButton from "./LastSalePrice";
import { usePermission } from "../../../context/PermissionContext";
import PercentIcon from "@mui/icons-material/Percent";
import {
  getOfferAmount,
  getOfferPercent,
  toPrimaryQuantity,
  toPrimaryUnitPrice,
  toSecondaryUnitPrice,
} from "@heartinz/finance";
import uRLs from "../../../utils/baseUtils";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import EditProduct from "../product/EditProduct";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import ProductOverView from "../product/ProductOverView";
import {
  AddIcon,
  CheckLgIcon,
  CloseIcon,
  CustomersSearchIcon,
  EditIcon,
  ExpandAltIcon,
  GridAltIcon,
  OfferIcon,
  PhoneIcon,
  SearchIcon,
} from "../../../constants/Icons";

const FindStock = ({
  data,
  addToCart,
  onClose,
  offer,
  customerSearchTerm,
  customerSuggestions,
  highlightedIndex,
  showCustomerDropdown,
  selectedCustomer,
  suggestionRefs,
  customerSuggestionsRef,
  handleCustomerSearch,
  handleSelectCustomer,
  handleCustomerKeyDown,
  handleKeyPress,
  setShowCustomerDropdown,
  mode,
  noteSuggests,
  brandSuggest,
  setBrandSuggest,
}) => {
  const FIELDS = {
    PERCENT: "percent",
    PRICE: "price",
    QTY: "qty",
    ADD: "add",
  };
  // console.log("FindStock props:", {
  //   data,
  //   offer,
  // });
  const [productData, setProductData] = useState(data);
  const isGroupedStock = data?.some((item) => item?.isGroupedStock === true);
  const isStockList = data?.some((item) => item?.isStockList === true);
  const [productViewData, setProductViewData] = useState([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [discountPercent, setDiscountPercent] = useState({});
  const [isOfferApplied, setIsOfferApplied] = useState([true]);
  const [isEditingPercent, setIsEditingPercent] = useState({});
  const [isPercentFocused, setIsPercentFocused] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  // values: "qty", "price", "percent"
  const [landingCost, setLandingCost] = useState({});
  const [selectedUnits, setSelectedUnits] = useState({});
  const [priceStates, setPriceStates] = useState({});

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSoldPriceFocused, setIsSoldPriceFocused] = useState(false);
  const inputRefs = useRef([]);
  const soldPriceRefs = useRef([]);
  const buttonRef = useRef(null);
  const percentRefs = useRef([]);
  const { viewOption, permission, hasPermission } = usePermission();

  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);

  const [isExpanded, setIsExpanded] = useState(
    data?.some((item) => item?.isStockList === true) || false,
  );
  const [expandedLoaded, setExpandedLoaded] = useState(false);
  const [expandedData, setExpandedData] = useState([]);
  const [isExpandLoading, setIsExpandLoading] = useState(false);

  const [productViewOpen, setProductViewOpen] = useState(false);

  const [productStockData, setPrductStockData] = useState([]);

  const handleExpand = () => {
    if (isGroupedStock) {
      return;
    }

    setIsExpanded(true);
  };

  const refreshStockData = async (productId) => {
    try {
      if (!checkNetwork()) return;

      // Always refresh grouped data
      const groupedResponse = await AxiosInstance.get(
        `module/stock/grouped/${productId}`,
      );

      setProductData(groupedResponse.data?.results || []);

      // If expanded view is open, also refresh individual stock list
      if (isExpanded) {
        const stockResponse = await AxiosInstance.get(
          `module/stock/${productId}`,
        );

        const stockArray = (stockResponse.data.results || []).map((item) => ({
          totalStockLeft: item.stockLeft,
          totalStockLeftUnit: item.stockLeftUnit,
          note: groupedResponse.data?.results?.[0]?.note || "",
          isStockList: true,
          landingcost: item.landingcost,
          stockData: {
            productid: item.productid,
            saleprice: item.saleprice,
            mrp: item.mrp,
            taxpercentage: item.taxpercentage,
            discount: item.discount,
            baseprice: item.baseprice,
            taxamount: item.taxamount,
            isLock: item.isLock,
            productData: {
              code: item.code,
              hsnsac: item.hsnsac,
              title: item.title,
              unitConfig: item.unitConfig,
            },
          },
        }));

        setExpandedData(stockArray);
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };
  // useEffect(() => {
  //   const initialValues = {};

  //   data.forEach((item, index) => {
  //     let salePriceSubunit = item.stockData.saleprice || 0;

  //     const offerPercent = parseFloat(offer);

  //     if (Number.isFinite(offerPercent) && offerPercent > 0) {
  //       salePriceSubunit = getOfferAmount(salePriceSubunit, offerPercent);
  //     }

  //     initialValues[index] = {
  //       qty: index === selectedIndex ? "1" : "",
  //       soldprice: CurrencyConverter.toCurrency(salePriceSubunit, "INR"),
  //     };
  //   });

  //   setInputValues(initialValues);
  // }, [data, selectedIndex, offer]);

  const displayData = isExpanded ? expandedData : productData;

  useEffect(() => {
    const initialValues = {};
    const percentValues = {};
    const initialUnits = {};
    const initialPriceStates = {};
    const initialLandingCost = {};

    displayData.forEach((item, index) => {
      let salePriceSubunit = item.stockData.saleprice || 0;
      const mrp = item.stockData.mrp || 0;

      if (isOfferApplied[index] && Number(offer) > 0) {
        salePriceSubunit = getOfferAmount(salePriceSubunit, Number(offer));
      }

      initialValues[index] = {
        qty: index === selectedIndex ? "1" : "",
        soldprice: CurrencyConverter.toCurrency(salePriceSubunit, "INR"),
      };

      initialUnits[index] =
        item?.stockData?.productData?.unitConfig?.primaryUnitCode || "";

      initialPriceStates[index] = {
        mrp: item.stockData.mrp,
        baseprice: item.stockData.baseprice,
      };

      percentValues[index] =
        discountPercent[index] ??
        getOfferPercent(mrp, salePriceSubunit)?.toString() ??
        "";

      initialLandingCost[index] = CurrencyConverter.toCurrency(
        item.landingcost || 0,
        "INR",
      );
    });

    setInputValues(initialValues);
    setDiscountPercent(percentValues);
    setSelectedUnits(initialUnits);
    setPriceStates(initialPriceStates);
    setLandingCost(initialLandingCost);
  }, [displayData, selectedIndex, offer, isOfferApplied]);

  useEffect(() => {
    if (!isSoldPriceFocused && inputRefs.current[selectedIndex]) {
      inputRefs.current[selectedIndex].focus();
      inputRefs.current[selectedIndex].select();
    }
  }, [selectedIndex, isSoldPriceFocused]);

  useEffect(() => {
    if (focusedField !== null) return;

    const timer = setTimeout(() => {
      const qtyInput = inputRefs.current[selectedIndex];

      if (qtyInput) {
        qtyInput.focus();
        qtyInput.select();
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [displayData, selectedIndex, isExpanded, focusedField]);

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const updateProductState = (updatedProduct) => {
    const updater = (item) =>
      item.stockData.productid === updatedProduct._id
        ? {
            ...item,
            landingcost: updatedProduct.landingcost || 0,
            stockData: {
              ...item.stockData,
              mrp: updatedProduct.mrp,
              saleprice: updatedProduct.saleprice,
              baseprice: updatedProduct.baseprice,
              taxpercentage: updatedProduct.taxpercentage,
              discount: updatedProduct.discount,
              taxamount: updatedProduct.taxamount,
              isLock: updatedProduct.isLock,
              productData: {
                ...item.stockData.productData,
                ...updatedProduct,
              },
            },
          }
        : item;

    setProductData((prev) => prev.map(updater));
    setExpandedData((prev) => prev.map(updater));

    setProductViewData((prev) =>
      prev && prev._id === updatedProduct._id
        ? {
            ...prev,
            title: updatedProduct.title,
            code: updatedProduct.code,
            hsnsac: updatedProduct.hsnsac,
            mrp: updatedProduct.mrp,
            saleprice: updatedProduct.saleprice,
            discount: updatedProduct.discount,
            baseprice: updatedProduct.baseprice,
            taxamount: updatedProduct.taxamount,
            landingcost: updatedProduct.landingcost || 0,
            taxpercentage: updatedProduct.taxpercentage,
            isLock: updatedProduct.isLock,
          }
        : prev,
    );
  };

  const handleUpdte = async (updatedData, imageFile, trigger = true) => {
    // console.log("UpdatedData", updatedData);
    const original = isEditData;

    const formData = new FormData();
    let isDataChanged = false;

    const appendIfChanged = (key, newVal, oldVal, transform = (v) => v) => {
      if (newVal !== oldVal) {
        formData.append(key, transform(newVal));
        isDataChanged = true;
      }
    };

    const isPriceGroupChanged =
      updatedData?.mrp !== original?.mrp ||
      updatedData?.saleprice !== original?.saleprice ||
      updatedData?.baseprice !== original?.baseprice ||
      updatedData?.taxpercentage !== original?.taxpercentage ||
      updatedData?.isLock !== original?.isLock;

    if (isPriceGroupChanged) {
      formData.append(
        "mrp",
        CurrencyConverter.toSubunit(updatedData?.mrp, "INR"),
      );
      formData.append(
        "saleprice",
        CurrencyConverter.toSubunit(updatedData?.saleprice, "INR"),
      );
      formData.append(
        "baseprice",
        CurrencyConverter.toSubunit(updatedData?.baseprice, "INR"),
      );
      formData.append("taxpercentage", updatedData?.taxpercentage);
      formData.append("isLock", updatedData?.isLock);

      isDataChanged = true;
    }

    const newMin = CurrencyConverter.toSubunit(
      Number(updatedData?.minimumSalePrice || 0),
      "INR",
    );

    const oldMin =
      typeof original?.minimumSalePrice === "number"
        ? original.minimumSalePrice
        : CurrencyConverter.toSubunit(
            Number(original?.minimumSalePrice || 0),
            "INR",
          );

    if (newMin !== oldMin) {
      formData.append("minimumSalePrice", newMin);
      isDataChanged = true;
    }
    appendIfChanged("code", updatedData?.code, original?.code);
    appendIfChanged(
      "hsnsac",
      updatedData?.hsnsac ?? "",
      original?.hsnsac ?? "",
    );
    appendIfChanged("title", updatedData?.title, original?.title);
    // appendIfChanged("taxpercentage", updatedData.taxpercentage, original.taxpercentage);
    // appendIfChanged("isLock", updatedData.isLock, original.isLock);
    appendIfChanged("note", updatedData?.note, original?.note);
    appendIfChanged(
      "searchTag",
      updatedData?.searchTag ?? "",
      original?.searchTag ?? "",
    );
    appendIfChanged(
      "brandId",
      updatedData?.brandData?.title ?? "",
      original?.brandId ?? "",
    );
    // appendIfChanged("mrp",updatedData.mrp,original.mrp,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("saleprice",updatedData.saleprice,original.saleprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    // appendIfChanged("baseprice",updatedData.baseprice,original.baseprice,(v) => CurrencyConverter.toSubunit(v, "INR"));
    appendIfChanged(
      "landingcost",
      updatedData?.landingcost || 0,
      original?.landingcost || 0,
      (v) => CurrencyConverter.toSubunit(v, "INR"),
    );

    const newUnit = updatedData?.unitConfig;
    const oldUnit = original?.unitConfig;

    if (
      !updatedData?.unitLocked &&
      JSON.stringify(newUnit) !== JSON.stringify(oldUnit)
    ) {
      formData.append("unitConfig", JSON.stringify(newUnit));
      isDataChanged = true;
    }
    if (imageFile instanceof File) {
      formData.append("primaryImage", imageFile);
      isDataChanged = true;
    }

    if (!isDataChanged) {
      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      if (trigger) closeEditModal();
      return true;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.patch(
        `module/product/update-product/${updatedData._id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      showAlert("success", Messages.SUCCESS.PRODUCT_UPDATED);
      const updatedProduct = response.data.results;

      updateProductState(updatedProduct);

      setProductData((prev) =>
        prev.map((item) =>
          item.stockData.productid === updatedProduct._id
            ? {
                ...item,
                landingcost: updatedProduct.landingcost || 0,
                stockData: {
                  ...item.stockData,
                  mrp: updatedProduct.mrp,
                  saleprice: updatedProduct.saleprice,
                  baseprice: updatedProduct.baseprice,
                  taxpercentage: updatedProduct.taxpercentage,
                  isLock: updatedProduct.isLock,
                  productData: {
                    ...item.stockData.productData,
                    ...updatedProduct,
                  },
                },
              }
            : item,
        ),
      );

      setExpandedData((prev) =>
        prev.map((item) =>
          item.stockData.productid === updatedProduct._id
            ? {
                ...item,
                landingcost: updatedProduct.landingcost || 0,
                stockData: {
                  ...item.stockData,
                  mrp: updatedProduct.mrp,
                  saleprice: updatedProduct.saleprice,
                  baseprice: updatedProduct.baseprice,
                  taxpercentage: updatedProduct.taxpercentage,
                  isLock: updatedProduct.isLock,
                  productData: {
                    ...item.stockData.productData,
                    ...updatedProduct,
                  },
                },
              }
            : item,
        ),
      );

      const productIndex = productData.findIndex(
        (item) => item.stockData.productid === updatedProduct._id,
      );

      const expandedIndex = expandedData.findIndex(
        (item) => item.stockData.productid === updatedProduct._id,
      );
      const index = expandedIndex !== -1 ? expandedIndex : productIndex;

      if (index !== -1) {
        setPriceStates((prev) => ({
          ...prev,
          [index]: {
            mrp: updatedProduct.mrp,
            baseprice: updatedProduct.baseprice,
          },
        }));

        setLandingCost((prev) => ({
          ...prev,
          [index]: CurrencyConverter.toCurrency(
            updatedProduct.landingcost || 0,
            "INR",
          ),
        }));

        setInputValues((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            soldprice: CurrencyConverter.toCurrency(
              updatedProduct.saleprice,
              "INR",
            ),
          },
        }));

        setDiscountPercent((prev) => ({
          ...prev,
          [index]: getOfferPercent(
            updatedProduct.mrp,
            updatedProduct.saleprice,
          )?.toString(),
        }));
      }
      if (trigger) closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleRadioChange = (newIndex) => {
    setInputValues((prevValues) => {
      const updatedValues = { ...prevValues };

      productData.forEach((item, index) => {
        updatedValues[index] = {
          qty: prevValues[index]?.qty ?? (index === newIndex ? "1" : ""),
          soldprice:
            prevValues[index]?.soldprice ??
            CurrencyConverter.toCurrency(item.stockData.saleprice || 0, "INR"),
        };
      });
      if (!updatedValues[newIndex].qty) {
        updatedValues[newIndex].qty = "1";
      }

      return updatedValues;
    });

    setSelectedIndex(newIndex);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`qty_${newIndex}`];
      delete updatedErrors[`soldprice_${newIndex}`];
      return updatedErrors;
    });
  };

  const handleQtyInputChange = (value, index) => {
    const stockIn = productData[index]?.totalStockLeft || 0;

    let parsedValue;

    if (
      productData[index]?.stockData?.productData?.unitConfig &&
      uRLs?.UNIT === "true"
    ) {
      parsedValue = value.replace(/[^0-9.]/g, "");

      const parts = parsedValue.split(".");

      // prevent multiple dots
      if (parts.length > 2) {
        parsedValue = parts[0] + "." + parts[1];
      }

      // allow 3 decimals
      if (parts[1]?.length > 3) {
        parsedValue = parts[0] + "." + parts[1].slice(0, 3);
      }
    } else {
      parsedValue = value.replace(/\D/g, "");
    }

    let numericValue = parsedValue ? parseFloat(parsedValue) : "";

    setErrors((prev) => {
      const updated = { ...prev };

      if (
        mode !== "PROFORMA" &&
        parsedValue !== "" &&
        !isNaN(numericValue) &&
        numericValue > stockIn
      ) {
        updated[`qty_${index}`] = `exceed stock`;
      } else {
        delete updated[`qty_${index}`];
      }

      return updated;
    });

    setInputValues((prevValues) => ({
      ...prevValues,
      [index]: {
        ...prevValues[index],
        qty: parsedValue,
      },
    }));

    // if (parsedValue !== "" && !isNaN(numericValue)) {
    //   setErrors((prevErrors) => {
    //     const updatedErrors = { ...prevErrors };
    //     delete updatedErrors[`qty_${index}`];
    //     return updatedErrors;
    //   });
    // }
  };

  const handleUnitChange = (newUnit, index) => {
    const item = productData[index];

    if (!item?.stockData?.productData?.unitConfig) return;

    const unitConfig = item.stockData.productData.unitConfig;

    const normalizedNewUnit = String(newUnit).trim();
    const secondaryUnit = String(unitConfig.secondaryUnitCode).trim();

    setSelectedUnits((prev) => ({
      ...prev,
      [index]: normalizedNewUnit,
    }));

    const isSwitchingToSecondary = normalizedNewUnit === secondaryUnit;

    const currentSoldPrice = parseFloat(inputValues[index]?.soldprice) || 0;

    const numericQty = parseFloat(inputValues[index]?.qty) || 1;

    let converted;

    if (isSwitchingToSecondary) {
      converted = toSecondaryUnitPrice(
        priceStates[index]?.mrp,
        CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
        priceStates[index]?.baseprice,
        item.stockData.taxpercentage,
        numericQty,
        "SALEPRICE",
        unitConfig,
      );
    } else {
      converted = toPrimaryUnitPrice(
        priceStates[index]?.mrp,
        CurrencyConverter.toSubunit(currentSoldPrice, "INR"),
        priceStates[index]?.baseprice,
        item.stockData.taxpercentage,
        numericQty,
        "SALEPRICE",
        unitConfig,
      );
    }

    const result = converted?.secondaryUnitPrice || converted?.primaryUnitPrice;

    if (!result) return;

    setInputValues((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        soldprice: CurrencyConverter.toCurrency(result.salePrice, "INR"),
      },
    }));

    setPriceStates((prev) => ({
      ...prev,
      [index]: {
        mrp: result.mrp,
        baseprice: result.basePrice,
      },
    }));
  };

  const handleSalePriceInputChange = (value, index) => {
    if (isOfferApplied[index]) {
      setIsOfferApplied((prev) => ({ ...prev, [index]: false }));
    }

    const mrp = CurrencyConverter.toCurrency(
      productData[index]?.stockData.mrp || 0,
      "INR",
    );

    let parsedValue = value.replace(/[^0-9.]/g, "");
    let numericValue = parseFloat(parsedValue);

    // ✅ Clamp BOTH parsedValue + numericValue
    if (!isNaN(numericValue) && numericValue > mrp) {
      numericValue = mrp; // 🔥 FIX
      parsedValue = mrp.toString();
    }

    setInputValues((prevValues) => ({
      ...prevValues,
      [index]: {
        ...prevValues[index],
        soldprice: parsedValue,
      },
    }));

    // ✅ Always use corrected numericValue
    if (!isNaN(numericValue) && numericValue > 0 && numericValue <= mrp) {
      const subunit = CurrencyConverter.toSubunit(numericValue, "INR");
      const percent = getOfferPercent(
        productData[index]?.stockData.mrp || 0,
        subunit,
      );

      setDiscountPercent((prev) => ({
        ...prev,
        [index]: percent?.toString() || "",
      }));
    }

    if (parsedValue !== "" && !isNaN(numericValue)) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`soldprice_${index}`];
        return updatedErrors;
      });
    }
  };
  const handlePercentChange = (value, index) => {
    if (isOfferApplied[index])
      setIsOfferApplied((prev) => ({ ...prev, [index]: false }));

    let parsed = value.replace(/[^0-9.]/g, "");

    if (parsed.startsWith("0") && !parsed.startsWith("0.")) {
      parsed = parsed.replace(/^0+/, "");
    }

    const parts = parsed.split(".");
    if (parts.length > 2) parsed = parts[0] + "." + parts[1];

    if (parts[1]?.length > 2) {
      parsed = parts[0] + "." + parts[1].slice(0, 2);
    }

    if (parseFloat(parsed) > 100) parsed = "100";

    setDiscountPercent((prev) => ({
      ...prev,
      [index]: parsed,
    }));

    setIsEditingPercent((prev) => ({
      ...prev,
      [index]: true,
    }));
  };

  const applyPercentage = (index) => {
    if (isOfferApplied[index])
      setIsOfferApplied((prev) => ({ ...prev, [index]: false }));

    const mrp = productData[index]?.stockData.mrp || 0;
    const percent = parseFloat(discountPercent[index]);

    if (isNaN(percent)) return;

    const newPrice = getOfferAmount(mrp, percent);

    setInputValues((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        soldprice: CurrencyConverter.toCurrency(newPrice, "INR"),
      },
    }));

    setIsEditingPercent((prev) => ({
      ...prev,
      [index]: false,
    }));
  };
  const handleStockDetails = async (product) => {
    try {
      if (!checkNetwork()) return;

      const productId = product?.[0]?.stockData?.productid;

      const response = await AxiosInstance.get(
        `module/stock/primary-store/${productId}`,
      );

      setPrductStockData(response.data?.results || []);
    } catch (error) {
      setPrductStockData([]);
      handleError(error, showAlert);
    }
  };

  const handleOpenProductView = async (product) => {
    setProductViewData({
      title: product[0].stockData.productData?.title,
      code: product[0].stockData.productData?.code,
      hsnsac: product[0].stockData.productData?.hsnsac,
      mrp: product[0].stockData?.mrp,
      saleprice: product[0].stockData?.saleprice,
      discount: product[0].stockData?.discount,
      baseprice: product[0].stockData?.baseprice,
      taxamount: product[0].stockData?.taxamount,
      landingcost: product[0]?.landingcost || 0,
      taxpercentage: product[0].stockData?.taxpercentage,
      _id: product[0].stockData?.productid,
      isLock: product[0].stockData?.isLock,
      isStock: true,
    });
    await handleStockDetails(product);
    setProductViewOpen(true);
  };

  const primaryQuanity = (quanity, unitData) => {
    const qty = toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  };

  // const updateStockProduct = (updatedData, stockData, quantity, isAdd) => {
  //   console.log("updateStockProduct", {
  //     updatedData,
  //     stockData,
  //     quantity,
  //     isAdd,
  //   });
  //   const totalStock =
  //     stockData?.reduce((total, item) => total + (item?.stockLeft || 0), 0) ??
  //     0;

  //   const stockQty =
  //     Number(
  //       updatedData?.stockLinkInfo?.isSecondaryUnit
  //         ? primaryQuanity(quantity, updatedData?.stockLinkInfo?.unitConfig)
  //         : quantity,
  //     ) || 0;

  //   const updatedStock = isAdd ? totalStock + stockQty : totalStock - stockQty;

  //   const updateProduct = (product) => {
  //     if (product.stockData.productid !== updatedData.productid) {
  //       return product;
  //     }

  //     return {
  //       ...product,
  //       totalStockLeft: updatedStock,
  //       landingcost: updatedData.landingcost ?? product.landingcost,
  //       stockData: {
  //         ...product.stockData,
  //         mrp: updatedData.mrp ?? product.stockData.mrp,
  //         saleprice: updatedData.saleprice ?? product.stockData.saleprice,
  //         baseprice: updatedData.baseprice ?? product.stockData.baseprice,
  //         discount: updatedData.discount ?? product.stockData.discount,
  //         taxamount: updatedData.taxamount ?? product.stockData.taxamount,
  //         taxpercentage:
  //           updatedData.taxpercentage ?? product.stockData.taxpercentage,
  //         isLock: updatedData.isLock ?? product.stockData.isLock,
  //         productData: {
  //           ...product.stockData.productData,
  //           title: updatedData.title ?? product.stockData.productData.title,
  //           code: updatedData.code ?? product.stockData.productData.code,
  //           hsnsac: updatedData.hsnsac ?? product.stockData.productData.hsnsac,
  //           unitConfig:
  //             updatedData.unitConfig ??
  //             product.stockData.productData.unitConfig,
  //         },
  //       },
  //     };
  //   };

  //   setProductData((prev) => prev.map(updateProduct));
  //   setExpandedData((prev) => prev.map(updateProduct));

  //   const productIndex = productData.findIndex(
  //     (item) => item.stockData.productid === updatedData.productid,
  //   );

  //   const expandedIndex = expandedData.findIndex(
  //     (item) => item.stockData.productid === updatedData.productid,
  //   );

  //   [...new Set([productIndex, expandedIndex].filter((i) => i !== -1))].forEach(
  //     (index) => {
  //       setPriceStates((prev) => ({
  //         ...prev,
  //         [index]: {
  //           mrp: updatedData.mrp,
  //           baseprice: updatedData.baseprice,
  //         },
  //       }));

  //       setLandingCost((prev) => ({
  //         ...prev,
  //         [index]: CurrencyConverter.toCurrency(
  //           updatedData.landingcost || 0,
  //           "INR",
  //         ),
  //       }));

  //       setInputValues((prev) => ({
  //         ...prev,
  //         [index]: {
  //           ...prev[index],
  //           soldprice: CurrencyConverter.toCurrency(
  //             updatedData.saleprice,
  //             "INR",
  //           ),
  //         },
  //       }));

  //       setDiscountPercent((prev) => ({
  //         ...prev,
  //         [index]: getOfferPercent(
  //           updatedData.mrp,
  //           updatedData.saleprice,
  //         )?.toString(),
  //       }));
  //     },
  //   );
  // };

  const onStockEditData = async (
    updatedData,
    stockData,
    quantity,
    isAdd = true,
  ) => {
    await refreshStockData(updatedData.productid);
  };

  const hadlTrashStockData = async (updatedData, stockData, quantity) => {
    await refreshStockData(updatedData.productid);
  };

  const handleAdd = () => {
    const selectedData = displayData[selectedIndex];
    const { qty, soldprice } = inputValues[selectedIndex] || {};

    const stockIn = selectedData.totalStockLeft;
    const numericQty = parseFloat(qty);
    if (mode !== "PROFORMA" && numericQty > stockIn) {
      setErrors((prev) => ({
        ...prev,
        [`qty_${selectedIndex}`]: `exceed stock`,
      }));

      inputRefs.current[selectedIndex]?.focus();
      return;
    }

    if (!soldprice || isNaN(parseFloat(soldprice))) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`soldprice_${selectedIndex}`]: "Enter a valid sale price.",
      }));
      soldPriceRefs.current[selectedIndex]?.focus();
      setIsSoldPriceFocused(true);
      return;
    }

    const numericSoldPrice = parseFloat(soldprice);
    if (numericSoldPrice > selectedData.mrp) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`soldprice_${selectedIndex}`]: "Sale price cannot exceed MRP.",
      }));
      soldPriceRefs.current[selectedIndex]?.focus();
      setIsSoldPriceFocused(true);
      return;
    }

    const newItem = {
      _id: selectedData.stockData.productid,
      code: selectedData.stockData.productData.code,
      hsnsac: selectedData.stockData.productData.hsnsac,
      title: selectedData.stockData.productData.title,
      mrp: selectedData.stockData.mrp,
      saleprice: selectedData.stockData.saleprice,
      soldprice: CurrencyConverter.toSubunit(numericSoldPrice, "INR"),
      taxpercentage: selectedData.stockData.taxpercentage,
      baseprice: selectedData.stockData.baseprice,
      discount: selectedData.stockData.discount,
      taxamount: selectedData.stockData.taxamount,
      isLock: selectedData.stockData.isLock,
      isStock: true,
      stockLeft: selectedData.totalStockLeft,
      note: selectedData.note,
      landingcost: CurrencyConverter.toSubunit(
        Number(landingCost[selectedIndex] || 0),
        "INR",
      ),

      ...(selectedData?.isStockList === true &&
        selectedData?.stockLinkId && {
          stockLinkId: selectedData.stockLinkId,
        }),
      ...(selectedData?.stockData?.productData?.unitConfig && {
        unitConfig: selectedData.stockData.productData.unitConfig,

        secondaryUnitSelected:
          selectedUnits[selectedIndex] ===
          selectedData.stockData.productData.unitConfig.secondaryUnitCode,
      }),
    };
    addToCart(newItem, qty, true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newIndex = (selectedIndex + 1) % productData.length;
      handleRadioChange(newIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex =
        (selectedIndex - 1 + productData.length) % productData.length;
      handleRadioChange(newIndex);
    } else if (e.key === "Enter") {
      buttonRef.current?.focus();
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleCloseProductView = () => {
    setProductViewOpen(false);
  };

  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setEditData({
        title: cItem[0].stockData.productData?.title,
        code: cItem[0].stockData.productData?.code,
        hsnsac: cItem[0].stockData.productData?.hsnsac,
        mrp: cItem[0].stockData?.mrp,
        saleprice: cItem[0].stockData?.saleprice,
        discount: cItem[0].stockData?.discount,
        baseprice: cItem[0].stockData?.baseprice,
        taxamount: cItem[0].stockData?.taxamount,
        landingcost: cItem[0]?.landingcost || 0,
        taxpercentage: cItem[0].stockData?.taxpercentage,
        _id: cItem[0].stockData?.productid,
        isLock: cItem[0].stockData?.isLock,
        isStock: true,
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const showLandingCost = isExpanded
    ? viewOption("saleSettings", "isLandingCost")
    : false;

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    setProductData(data);

    const stockList = data?.some((item) => item?.isStockList === true);

    setIsExpanded(stockList);
    setExpandedData(stockList ? data : []);
  }, [data]);

  useEffect(() => {
    setProductData(data);
  }, [data]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title mb-0">Stock Availability</h6>

              <div className="d-flex align-items-center gap-2">
                <div className="toggle-switch">
                  <div
                    className={`toggle-slider ${isExpanded ? "right" : "left"}`}
                  ></div>

                  {/* GROUP */}
                  <button
                    type="button"
                    className={`toggle-item ${!isExpanded ? "active" : ""}`}
                    onClick={() => {
                      if (!isStockList) {
                        setIsExpanded(false);
                      }
                    }}
                    disabled={isStockList}
                  >
                    <GridAltIcon iClass={"ms-1"} />
                    Group
                  </button>

                  {/* EXPAND */}
                  <button
                    type="button"
                    className={`toggle-item ${isExpanded ? "active" : ""}`}
                    onClick={() => {
                      if (!isGroupedStock) {
                        setIsExpanded(true);
                      }
                    }}
                    disabled={isGroupedStock}
                  >
                    {isExpandLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      <>
                        <ExpandAltIcon iClass={"me-1"} />
                        Expand
                      </>
                    )}
                  </button>
                </div>

                <button
                  type="button"
                  onClick={onClose}
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="modal-body">
              <div>
                <div className="d-flex justify-content-start gap-2">
                  {[
                    ...new Map(
                      displayData.map((item) => [
                        item?.stockData.productData.code,
                        {
                          title: item?.stockData.productData.title,
                          code: item?.stockData.productData.code,
                        },
                      ]),
                    ).values(),
                  ].map((product, index) => (
                    <h6 key={index} className="mb-2 bg-text">
                      <span className="badge rounded-pill bg-label-navy">
                        {product.code}
                      </span>{" "}
                      - {product.title}
                    </h6>
                  ))}

                  <button
                    type="button"
                    className="btn-label-primary rounded shadow-none border-0 cursor-pointer mb-2"
                    onClick={() => handleOpenProductView(data)}
                  >
                    <EditIcon /> Product
                  </button>
                </div>
                <div>
                  <div className="d-flex align-items-center mb-3 mt-3">
                    <div style={{ width: "165px" }}>
                      <div
                        className="border rounded d-flex align-items-center ps-1"
                        style={{ height: "32px" }}
                      >
                        <span className="text-muted fs-13 ms-1 me-2">
                          Discount
                        </span>
                        <span className="text-muted me-1">
                          <PercentIcon style={{ fontSize: "14px" }} />
                        </span>

                        <input
                          type="text"
                          className="form-control border-0 p-0 text-center flex-grow-1"
                          style={{
                            boxShadow: "none",
                            height: "auto",
                            background: "transparent",
                            minWidth: "10px",
                          }}
                          value={discountPercent[selectedIndex] || ""}
                          onFocus={(e) => {
                            setFocusedField("percent");
                            e.target.select();
                          }}
                          // onBlur={() => setFocusedField(null)}
                          onChange={(e) =>
                            handlePercentChange(e.target.value, selectedIndex)
                          }
                          onBlur={() => {
                            if (isEditingPercent[selectedIndex]) {
                              applyPercentage(selectedIndex);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              applyPercentage(selectedIndex);

                              setFocusedField(FIELDS.PRICE);

                              setTimeout(() => {
                                soldPriceRefs.current[selectedIndex]?.focus();
                                soldPriceRefs.current[selectedIndex]?.select();
                              }, 0);
                            }
                          }}
                        />

                        {isEditingPercent[selectedIndex] && (
                          <span
                            className="btn btn-sm btn-label-success p-1  shadow-none"
                            onClick={() => {
                              applyPercentage(selectedIndex);

                              setFocusedField("soldprice"); // ✅ prevent qty override

                              setTimeout(() => {
                                soldPriceRefs.current[selectedIndex]?.focus();
                                soldPriceRefs.current[selectedIndex]?.select();
                              }, 0);
                            }}
                          >
                            <CheckLgIcon iClass={"fs-6"} />
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                      {!selectedCustomer ? (
                        !showCustomerDropdown ? (
                          <div className="d-flex justify-content-center align-items-center gap-1">
                            <p className=" mb-0 fs-13">
                              <strong>Last Sale Price :</strong>
                            </p>
                            <button
                              className="btn btn-light-primary btn-sm d-flex align-items-center gap-2 shadow-none"
                              onClick={() => setShowCustomerDropdown(true)}
                            >
                              <CustomersSearchIcon iClass={"mt-1"} />
                              Select Customer
                            </button>
                          </div>
                        ) : (
                          <div className="col-lg-3 text-center position-relative">
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="search"
                                autoComplete="off"
                                ref={customerSuggestionsRef}
                                value={customerSearchTerm}
                                onChange={(e) =>
                                  handleCustomerSearch(e.target.value)
                                }
                                onKeyPress={handleKeyPress}
                                onKeyDown={handleCustomerKeyDown}
                                onFocus={() => {
                                  if (customerSuggestions.length > 0) {
                                    setShowCustomerDropdown(true);
                                  }
                                }}
                                placeholder="Search customer by name, phone, email, referenceID..."
                              />
                              <span className="input-group-text">
                                <SearchIcon />
                              </span>
                            </div>

                            {customerSearchTerm &&
                              customerSuggestions.length === 0 && (
                                <ul className="suggestions-list position-absolute w-100 bg-white border rounded shadow-sm z-3 mt-1">
                                  <li className="suggestion-item text-muted px-3 py-2">
                                    No customers data was found
                                  </li>
                                </ul>
                              )}

                            {showCustomerDropdown &&
                              customerSuggestions.length > 0 && (
                                <ul
                                  className="suggestions-list position-absolute w-100 bg-white border rounded shadow-sm z-3 mt-1"
                                  style={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {customerSuggestions.map(
                                    (customer, index) => (
                                      <li
                                        ref={(el) =>
                                          (suggestionRefs.current[index] = el)
                                        }
                                        key={customer._id}
                                        onClick={() =>
                                          handleSelectCustomer(customer)
                                        }
                                        className={`suggestion-item px-3 py-2 cursor-pointer ${
                                          highlightedIndex === index
                                            ? "bg-primary text-white"
                                            : ""
                                        }`}
                                      >
                                        {customer.name} -{" "}
                                        <span className="badge bg-label-blue rounded-pill">
                                          {customer.phone}
                                        </span>
                                        {customer.referenceid && (
                                          <>
                                            <small> - </small>
                                            <span className="badge bg-label-secondary rounded-pill">
                                              {customer.referenceid}
                                            </span>
                                          </>
                                        )}
                                      </li>
                                    ),
                                  )}
                                </ul>
                              )}
                          </div>
                        )
                      ) : (
                        <div className="text-center border rounded bg-light px-3 py-2">
                          <p className="mb-0 fs-14">
                            {selectedCustomer.customerData.name}
                          </p>
                          <p className="mb-0 fs-14">
                            <PhoneIcon iClass={"fs-15"} />{" "}
                            {selectedCustomer.customerData.phone}
                          </p>
                          <p className="mb-0 fs-14">
                            {Array.isArray(productData) &&
                              productData.length > 0 &&
                              productData[0].stockData?.productid &&
                              selectedCustomer?.customerData?._id && (
                                <LastSalePriceButton
                                  key={productData[0].stockData.productid}
                                  productId={productData[0].stockData.productid}
                                  customerId={selectedCustomer.customerData._id}
                                />
                              )}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4">
                  <div>
                    {Array.isArray(recent) &&
                      recent.length > 0 &&
                      recent
                        .flatMap((sale) =>
                          sale.saleitems?.[0] ? [sale.saleitems[0]] : []
                        )
                        .map((product, index) => (
                          <h6 key={index} className="mb-3 bg-text text-end">
                            Last sale price:{" "}
                            <span className="badge bg-label-fall rounded-pill">
                              ₹
                              {CurrencyConverter.toCurrency(
                                product?.soldprice || 0,
                                "INR"
                              )}
                            </span>
                          </h6>
                        ))}
                  </div>
                </div> */}
              </div>

              <table className="table align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th></th>
                    <th className="text-center">MRP</th>
                    <th className="text-center">
                      Sale Price{" "}
                      {isOfferApplied && offer && (
                        <span className="badge bg-warning text-dark">
                          <OfferIcon /> -{offer}%
                        </span>
                      )}
                    </th>
                    <th className="text-center">Tax(%)</th>
                    <th className="text-center">Stock Left</th>
                    {showLandingCost && (
                      <th className="text-center">Landing Cost</th>
                    )}
                    <th className="text-center w-15">Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {displayData.map((item, index) => (
                    <tr
                      key={index}
                      className={selectedIndex === index ? "selected-row" : ""}
                      style={{
                        backgroundColor:
                          selectedIndex === index ? "#f0f8ff" : "transparent",
                      }}
                      onClick={() => handleRadioChange(index)}
                    >
                      <td>
                        <input
                          className="input"
                          type="radio"
                          name="productSelection"
                          value={`${item.stockData.productid}${index}`}
                          checked={selectedIndex === index}
                          onChange={() => handleRadioChange(index)}
                        />
                      </td>
                      <td className="text-center">
                        ₹
                        {CurrencyConverter.toCurrency(
                          item.stockData.mrp || 0,
                          "INR",
                        )}
                      </td>

                      <td className="text-center wx-200">
                        <div
                          className="position-relative mx-auto"
                          style={{ width: "120px" }} // same as input width
                        >
                          <input
                            type="text"
                            name="soldprice"
                            autoComplete="off"
                            className="form-control text-center"
                            value={inputValues[index]?.soldprice || ""}
                            onChange={(e) =>
                              handleSalePriceInputChange(e.target.value, index)
                            }
                            onFocus={(e) => {
                              setFocusedField(FIELDS.PRICE); // ✅ correct
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();

                                setFocusedField(FIELDS.QTY);

                                setTimeout(() => {
                                  inputRefs.current[selectedIndex]?.focus();
                                  inputRefs.current[selectedIndex]?.select();
                                }, 0);
                              }
                            }}
                            // onBlur={() => setFocusedField(null)}
                            ref={(el) => (soldPriceRefs.current[index] = el)}
                            maxLength={String(item.mrp).length + 2}
                            disabled={
                              !viewOption("saleSettings", "modifySalePrice")
                            }
                          />
                          {/* {offer && (
                            <span
                              className="position-absolute text-danger"
                              style={{
                                top: "-6px",
                                right: "0px",
                                left: "120px",
                                fontSize: "10px",
                                fontWeight: "600",
                              }}
                            >
                              -{offer}%
                            </span>
                          )} */}
                        </div>
                        {errors[`soldprice_${index}`] && (
                          <div className="invalid-feedback d-block text-center">
                            {errors[`soldprice_${index}`]}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <span className="badge rounded-pill bg-label-peace">
                          {item.stockData.taxpercentage
                            ? `${item.stockData.taxpercentage}%`
                            : "0%"}
                        </span>
                      </td>
                      <td className="text-center">
                        <span className="badge bg-label-space">
                          {item.totalStockLeft}{" "}
                          {item?.stockData?.productData?.unitConfig &&
                            uRLs?.UNIT === "true" &&
                            item.stockData.productData.unitConfig
                              .primaryUnitCode}
                        </span>
                      </td>
                      {showLandingCost && (
                        <td className="text-center">
                          {displayData[0]?.isStockList
                            ? landingCost[index] || "0"
                            : item.landingcost
                              ? `₹ ${CurrencyConverter.toCurrency(
                                  item.landingcost || 0,
                                  "INR",
                                )}`
                              : "₹ 0"}
                        </td>
                      )}
                      <td className="wx-170">
                        <div className="input-group">
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control text-center"
                            ref={(el) => (inputRefs.current[index] = el)}
                            value={inputValues[index]?.qty || ""}
                            onChange={(e) =>
                              handleQtyInputChange(e.target.value, index)
                            }
                            onFocus={(e) => {
                              setFocusedField("qty");
                              setTimeout(() => e.target.select(), 0);
                            }}
                            onKeyDown={handlePaymodeKeyDown}
                            maxLength={10}
                          />

                          {item?.stockData?.productData?.unitConfig &&
                            uRLs?.UNIT === "true" &&
                            (item.stockData.productData.unitConfig
                              .secondaryUnitCode ? (
                              <select
                                className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                                value={
                                  selectedUnits[index] ||
                                  item.stockData.productData.unitConfig
                                    .primaryUnitCode
                                }
                                onChange={(e) =>
                                  handleUnitChange(e.target.value, index)
                                }
                              >
                                <option
                                  value={
                                    item.stockData.productData.unitConfig
                                      .primaryUnitCode
                                  }
                                >
                                  {
                                    item.stockData.productData.unitConfig
                                      .primaryUnitCode
                                  }
                                </option>

                                {/* <option
                                  value={
                                    item.stockData.productData.unitConfig
                                      .secondaryUnitCode
                                  }
                                >
                                  {
                                    item.stockData.productData.unitConfig
                                      .secondaryUnitCode
                                  }
                                </option> */}
                              </select>
                            ) : (
                              <span className="btn btn-unit shadow-none border-end rounded-end rounded-start-0">
                                {
                                  item.stockData.productData.unitConfig
                                    .primaryUnitCode
                                }
                              </span>
                            ))}
                        </div>

                        {errors[`qty_${index}`] && (
                          <div className="invalid-feedback d-block text-center">
                            {errors[`qty_${index}`]}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"} /> Cancel
              </button>
              <button
                ref={buttonRef}
                onClick={handleAdd}
                disabled={
                  !!errors[`qty_${selectedIndex}`] ||
                  !inputValues[selectedIndex]?.qty
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();

                    setFocusedField(FIELDS.ADD);

                    setTimeout(() => {
                      buttonRef.current?.focus();
                    }, 0);
                  }
                }}
                type="button"
                className={`btn ${
                  mode === "PROFORMA" ? "btn-porforma" : "btn-primary"
                } text-right`}
              >
                <AddIcon /> Add
              </button>
            </div>
          </div>
        </div>

        {/* {isEditModalOpen && (
          <EditProduct
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdte}
            isBtnLoading={isBtnLoading}
            noteSuggests={noteSuggests}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )} */}

        {productViewOpen && (
          <ProductOverView
            onClose={handleCloseProductView}
            onData={productViewData}
            onStockData={productStockData}
            onUpdate={handleUpdte}
            noteSuggests={noteSuggests}
            isBtnLoading={isBtnLoading}
            setProductData={setProductData}
            onStockEditData={onStockEditData}
            OnStockTrashData={hadlTrashStockData}
            // handleDeteleDataUpdate={handleDeteleDataUpdate}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}
      </div>
    </div>
  );
};

export default FindStock;
